var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatCalendar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 17.5,
    height: 20,
    viewBox: "0 0 17.5 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Container"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Symbol",
    d: "M5.9375 0.9375C5.88542 0.364583 5.57292 0.0520833 5 0C4.42708 0.0520833 4.11458 0.364583 4.0625 0.9375V2.5H2.5C1.79688 2.52604 1.21094 2.77344 0.742188 3.24219C0.273438 3.71094 0.0260417 4.29688 0 5V5.625V7.5V17.5C0.0260417 18.2031 0.273438 18.7891 0.742188 19.2578C1.21094 19.7266 1.79688 19.974 2.5 20H15C15.7031 19.974 16.2891 19.7266 16.7578 19.2578C17.2266 18.7891 17.474 18.2031 17.5 17.5V7.5V5.625V5C17.474 4.29688 17.2266 3.71094 16.7578 3.24219C16.2891 2.77344 15.7031 2.52604 15 2.5H13.4375V0.9375C13.3854 0.364583 13.0729 0.0520833 12.5 0C11.9271 0.0520833 11.6146 0.364583 11.5625 0.9375V2.5H5.9375V0.9375V0.9375V0.9375M1.875 7.5H15.625V17.5C15.599 17.8906 15.3906 18.099 15 18.125H2.5C2.10938 18.099 1.90104 17.8906 1.875 17.5V7.5V7.5V7.5",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatCalendar);
export default __webpack_public_path__ + "static/media/stat-calendar.fa6731ece426b45d72d4a4dd78af13a8.svg";
export { ForwardRef as ReactComponent };